import React, { Component } from "react";
import PropTypes from "prop-types";
import { Header, AsideLeft, AsideRight } from "../../components";
import { Modals } from "../../views";
import { appConfig } from "../../config";
import { navigation } from "../../models";
import MainRoutes from "../../routes/MainRoutes";
import auth from "../../services/auth";
import { userActions } from "../../redux/actions/user";
import { sideMenuActions } from "../../redux/actions/sideMenu";
import { bindActionCreators, compose } from "redux";
import { withRouter } from "react-router";
import { connect } from "react-redux";
import { authHeader } from "../../_helpers/auth-header";
import Login from "../../views/admin/login";
import Authorization from "../../routes/Authorization";
// #endregion

class App extends Component {
  constructor(props) {
    super(props);
  }
  static propTypes = {
    sideMenuIsCollapsed: PropTypes.bool,
    user: PropTypes.shape({
      login: PropTypes.string,
      firstname: PropTypes.string,
      lastname: PropTypes.string,
    }),
    userIsConnected: PropTypes.bool,
    currentView: PropTypes.string,
    actions: PropTypes.shape({
      enterHome: PropTypes.func,
      leaveHome: PropTypes.func,
      fetchEarningGraphDataIfNeeded: PropTypes.func,
      getUserRequest: PropTypes.func,
      openSideMenu: PropTypes.func,
      closeSideMenu: PropTypes.func,
      toggleSideMenu: PropTypes.func,
    }),
  };

  state = {
    appName: appConfig.appName,
    connectionStatus: appConfig.connectionStatus,
    helloWord: appConfig.helloWord,
    isAuthenticated: false,
    isLoading: true,
  };

  // #region lifecycle methods
  componentDidMount() {
    const token = auth.getToken();

    try {
      if (token !== "") {
        this.setState({ isAuthenticated: true, isLoading: false });
      } else {
        this.setState({ isAuthenticated: false, isLoading: false });
      }
    } catch (error) {
      this.setState({ isLoading: false });
      alert("You are not authenticated for login!");
    }
  }

  render() {
    const { isAuthenticated, isLoading } = this.state;

    const userinfo = auth.getUserInfo();
    if (!userinfo) {
      this.props.history.push("/");
      location.reload();
    }

    const { user, sideMenuIsCollapsed, currentView, userIsConnected } =
      this.props;
    const { appName, connectionStatus, helloWord } = this.state;
    let userTypeRole;
    if (
      [1, 2].includes(parseInt(localStorage.getItem("userTypeID"))) == false
    ) {
      userTypeRole = "default";
    } else {
      userTypeRole =
        userinfo.userTypeName == "subadmin" ? "admin" : userinfo.userTypeName;
    }

    const firstnamevalidate = "";
    const lastnamevalidate = "";

    if (userinfo.firstName) {
      const firstnamevalidate = userinfo.firstName;
    }

    if (userinfo.lastName) {
      const lastnamevalidate = userinfo.lastName.toUpperCase();
    }

    const userFullName = `${firstnamevalidate} ${lastnamevalidate}`;
    return (
      <div className="panle-wrapper">
        {alert.message && (
          <div className={`alert ${alert.type}`}>{alert.message}</div>
        )}
        <Header
          appName={appName}
          userFirstname={userinfo.firstName}
          userLastname={userinfo.lastName}
          currentView={currentView}
          toggleSideMenu={this.handlesMenuButtonClick}
        />
        <div className="wrapper row-offcanvas row-offcanvas-left">
          <AsideLeft
            isAnimated={true}
            mainNavigation={navigation.mainNavigation[userTypeRole]}
            currentView={currentView}
            isCollapsed={sideMenuIsCollapsed}
            helloWord={helloWord}
            connectionStatus={connectionStatus}
            // userIsConnected={userIsConnected}
            userIsConnected={userinfo.status}
            username={userinfo.userName}
            usertype={userinfo.userTypeName}
            onLogout={this.handlesOnLogout}
            //userPicture={userInfos.picture}
            //showPicture={userInfos.showPicture}
          />
          {/* } */}
          <AsideRight isAnimated={true} isExpanded={sideMenuIsCollapsed}>
            <MainRoutes />
          </AsideRight>
        </div>
        {/* modals cannot be placed anywhere (avoid backdrop or modal placement issues) so all grouped in same component and outside .wrapper*/}
        <Modals />
      </div>
    );
  }

  // #endregion
  handlesMenuButtonClick = (event) => {
    if (event) {
      event.preventDefault();
    }
    const {
      actions: { toggleSideMenu },
    } = this.props;
    toggleSideMenu();
  };

  handlesOnLogout = (event) => {
    if (event) {
      event.preventDefault();
      event.stopPropagation();
    }

    const { dispatch } = this.props;

    try {
      const {
        actions: { logout },
      } = this.props;
      logout();
      auth.clearAllAppStorage();
      auth.clearToken();
    } catch (error) {}
  };
}

export default App;



// WEBPACK FOOTER //
// ./src/app/containers/app/App.js